
import React from "react";
// import { useLocation } from "react-router-dom";
import NotificationListPage from "components/Notifications/NotificationListPage";





function SignageNotificationsListPage() {
    //   const location = useLocation();

    // Determine the base route based on current location
    //   const isSignageTeammember = location.pathname.includes('/signageteammember');
    //   const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';
    //    <NotificationListPage baseRoute={baseRoute} />;
    return <NotificationListPage />;
}
export default SignageNotificationsListPage;